import { cn } from '../../utils/classNames';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import XButton from '../common/XButton';
import TooltipWrapper from '../ui-control/TooltipWrapper';
import {
  columnClasses,
  footerActionsClasses,
  footerClasses,
  footerInnerClasses,
  footerLabelClasses
} from './easyModeClasses';

const EasyModeFooter = ({
  step,
  totalSteps,
  label,
  isBackVisible = false,
  onBack,
  primaryLabel,
  primaryIcon,
  primaryVariant = 'primary',
  isPrimaryDisabled = false,
  isPrimaryLoading = false,
  primaryTooltip = '',
  onPrimary
}) => (
  <footer className={footerClasses}>
    <div className={cn(columnClasses, footerInnerClasses)}>
      <span className={footerLabelClasses}>
        {`Step ${step} of ${totalSteps} - ${label}`}
      </span>
      <div className={footerActionsClasses} data-tour={TOUR_TARGETS.EASY_MODE_GENERATE}>
        {isBackVisible && (
          <XButton variant="link" onClick={onBack}>
            Back
          </XButton>
        )}
        <TooltipWrapper
          showTooltip={Boolean(primaryTooltip)}
          title={primaryTooltip}
          variant="error"
        >
          {/* a disabled button emits no hover events, so the tooltip needs an enabled wrapper */}
          <span>
            <XButton
              variant={primaryVariant}
              disabled={isPrimaryDisabled}
              loading={isPrimaryLoading}
              onClick={onPrimary}
            >
              {primaryIcon}
              {primaryLabel}
            </XButton>
          </span>
        </TooltipWrapper>
      </div>
    </div>
  </footer>
);

export default EasyModeFooter;
